export default __webpack_public_path__ + "static/media/global_chat.b73c3a8d.svg";